export class Tokens {
    public static readonly TEST = "Basic UTZMaXFCcFA6VEs3XzdvUDU=";

    public static readonly PROD = "Basic UTZMaXFCcFA6alhHKng2Rk8=";
}
